/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Benefits_PlaceholderInputs */

const en_candidate_profile_benefits_placeholder = /** @type {(inputs: Candidate_Profile_Benefits_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Flexible hours, Home office`)
};

const de_candidate_profile_benefits_placeholder = /** @type {(inputs: Candidate_Profile_Benefits_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Flexible Arbeitszeiten, Homeoffice`)
};

/**
* | output |
* | --- |
* | "e.g., Flexible hours, Home office" |
*
* @param {Candidate_Profile_Benefits_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_benefits_placeholder = /** @type {((inputs?: Candidate_Profile_Benefits_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Benefits_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_benefits_placeholder(inputs)
	return en_candidate_profile_benefits_placeholder(inputs)
});